import React, { useMemo } from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Row = ({
  padding = false,
  margin = false,
  paddingTopSm = false,
  container = false,
  animated,
  step = 100,
  topPaddingOff,
  bottomPaddingOff,
  animation = {
    "data-aos": "fade-up",
    "data-aos-delay": 100,
    "data-aos-duration": "1000"
  },
  position = 1,
  children,
  className,
  style,
  version = "v1",
  ...props
}) => {
  const anim = useMemo(
    () => animated ? {
      ...animation,
      "data-aos-delay": step * position
    } : {},
    [animation, animated, step, position]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, className, {
        [styles.padding]: padding,
        [styles.margin]: margin,
        [styles["no-top-padding"]]: topPaddingOff,
        [styles["no-bottom-padding"]]: bottomPaddingOff,
        [styles["padding-top-sm"]]: paddingTopSm,
        [styles["container"]]: container,
        [styles[version]]: !!version
      }),
      style,
      ...anim
    },
    children
  );
};
Row.displayName = "Page.Row";

export { Row };
//# sourceMappingURL=index.js.map
